import { Tab, Tabs } from "@mui/material";
import { useState } from "react";
import { CustomTabPanel } from "src/components/genericComponents";
import "./TableList.css";
import { DataSheet, DeckInfo, TableInfo } from "src/components/types";
import TableTile from "src/components/TableTile";
import { Socket } from "socket.io-client";

type TableListProps = {
  projectName: string;
  tables: TableInfo[];
  myTables: TableInfo[];
  socket: Socket;
  dataSheet: DataSheet;
  options: { [key: string]: any };
  decks: { [key: string]: DeckInfo };
  loadMore?: (status: string, numberOfTables: number) => void;
  showAllOptions: boolean;
};

function TableList(props: TableListProps) {
  const [selectedPanelStatus, setSelectedPanelStatus] = useState("open");

  function loadMoreTables() {
    let tableCount = 0;
    switch (selectedPanelStatus) {
      case "my":
        tableCount = props.myTables.length;
        break;
      case "open":
        tableCount = props.tables.filter((table) => table.status === "open").length;
        break;
      case "midgame":
        tableCount = props.tables.filter((table) => table.status === "midgame").length;
        break;
      case "ended":
        tableCount = props.tables.filter((table) => table.status === "ended").length;
        break;
    }
    props.loadMore?.(selectedPanelStatus, tableCount);
  }

  const tabSx = {
    transition: "all 0.3s",
    fontSize: "1.2rem",
    fontWeight: "bold",
    color: "white",
    borderRadius: "8px",
    border: "2px solid white",
    marginRight: "8px",
    marginTop: "0.5rem",
    "&.Mui-selected": {
      backgroundColor: "rgba(255, 255, 255, 0.7)",
      color: "black",
      border: "2px solid transparent",
    },
  };

  let myTableTiles = props.myTables.map((table) => (
    <TableTile
      key={table.tableId}
      tableInfo={table}
      projectName={props.projectName}
      dataSheet={props.dataSheet}
      options={props.options}
      decks={props.decks}
      socket={props.socket}
      showAllOptions={props.showAllOptions}
    />
  ));
  let openTableTiles = props.tables
    .filter((table) => table.status === "open")
    .map((table) => (
      <TableTile
        key={table.tableId}
        tableInfo={table}
        projectName={props.projectName}
        dataSheet={props.dataSheet}
        options={props.options}
        decks={props.decks}
        socket={props.socket}
        showAllOptions={props.showAllOptions}
      />
    ));
  let midgameTableTiles = props.tables
    .filter((table) => table.status === "midgame")
    .map((table) => (
      <TableTile
        key={table.tableId}
        tableInfo={table}
        projectName={props.projectName}
        dataSheet={props.dataSheet}
        options={props.options}
        decks={props.decks}
        socket={props.socket}
        showAllOptions={props.showAllOptions}
      />
    ));
  let endedTableTiles = props.tables
    .filter((table) => table.status === "ended")
    .map((table) => (
      <TableTile
        key={table.tableId}
        tableInfo={table}
        projectName={props.projectName}
        dataSheet={props.dataSheet}
        options={props.options}
        decks={props.decks}
        socket={props.socket}
        showAllOptions={props.showAllOptions}
      />
    ));

  return (
    <>
      <div className="table-list-redesign-tabs-container">
        <Tabs
          value={selectedPanelStatus}
          onChange={(e, newValue) => setSelectedPanelStatus(newValue)}
          TabIndicatorProps={{
            sx: { backgroundColor: "transparent" },
          }}
        >
          <Tab label="Open tables" value={"open"} sx={tabSx} />
          <Tab label="Midgame tables" value={"midgame"} sx={tabSx} />
          <Tab label="Ended tables" value={"ended"} sx={tabSx} />
          <Tab label="My tables" value={"my"} sx={tabSx} />
        </Tabs>
      </div>
      <div className="table-list-redesign-content-container">
        <CustomTabPanel value={selectedPanelStatus} compareValue={"open"}>
          {openTableTiles.length > 0 ? (
            <div className="table-list-redesign-tiles-container">{openTableTiles}</div>
          ) : (
            <div className="table-list-redesign-no-tables-message">No open tables available.</div>
          )}
        </CustomTabPanel>
        <CustomTabPanel value={selectedPanelStatus} compareValue={"midgame"}>
          {midgameTableTiles.length > 0 ? (
            <div className="table-list-redesign-tiles-container">{midgameTableTiles}</div>
          ) : (
            <div className="table-list-redesign-no-tables-message">No midgame tables available.</div>
          )}
        </CustomTabPanel>
        <CustomTabPanel value={selectedPanelStatus} compareValue={"ended"}>
          {endedTableTiles.length > 0 ? (
            <div className="table-list-redesign-tiles-container">{endedTableTiles}</div>
          ) : (
            <div className="table-list-redesign-no-tables-message">No ended tables available.</div>
          )}
        </CustomTabPanel>
        <CustomTabPanel value={selectedPanelStatus} compareValue={"my"}>
          {myTableTiles.length > 0 ? (
            <div className="table-list-redesign-tiles-container">{myTableTiles}</div>
          ) : (
            <div className="table-list-redesign-no-tables-message">You have no tables.</div>
          )}
        </CustomTabPanel>
      </div>
      <button className="table-list-redesign-load-more-button" onClick={loadMoreTables}>
        Load more
      </button>
    </>
  );
}

export default TableList;
